module.exports = __webpack_public_path__ + "static/media/notification.398db795.svg";